import { differenceInDays, differenceInHours, differenceInMinutes } from "date-fns";

/**
 * Calcula o tempo relativo entre duas datas considerando o fuso horário GMT-3 (Brasília)
 * @param date - Data de referência (geralmente updated_at)
 * @param baseDate - Data base para comparação (padrão: agora)
 * @returns String formatada com o tempo relativo
 */
export function getTimeAgo(date: string | Date, baseDate: Date = new Date()): string {
  try {
    const targetDate = new Date(date);
    
    const brasiliaOffset = -3 * 60;
    const adjustedTargetDate = new Date(targetDate.getTime() + brasiliaOffset * 60 * 1000);
    const adjustedBaseDate = new Date(baseDate.getTime() + brasiliaOffset * 60 * 1000);
    
    const minutesDiff = differenceInMinutes(adjustedBaseDate, adjustedTargetDate);
    const hoursDiff = differenceInHours(adjustedBaseDate, adjustedTargetDate);
    const daysDiff = differenceInDays(adjustedBaseDate, adjustedTargetDate);
    
    if (minutesDiff < 1) {
      return "agora mesmo";
    } else if (minutesDiff < 60) {
      return `${minutesDiff} minuto${minutesDiff > 1 ? 's' : ''}`;
    } else if (hoursDiff < 24) {
      return `${hoursDiff} hora${hoursDiff > 1 ? 's' : ''}`;
    } else if (daysDiff < 30) {
      return `${daysDiff} dia${daysDiff > 1 ? 's' : ''}`;
    } else {
      return adjustedTargetDate.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  } catch (error) {
    console.error('Erro ao calcular tempo relativo:', error);
    return "data inválida";
  }
}

/**
 * Calcula especificamente o tempo desde a última solicitação com mensagem mais intuitiva
 * @param updatedAt - Data da última atualização
 * @returns String formatada para "última solicitação faz X horas"
 */
export function getLastRequestTime(updatedAt: string | Date): string {
  const timeAgo = getTimeAgo(updatedAt);
  
  // Se for "agora mesmo", mostra uma mensagem mais clara
  if (timeAgo === "agora mesmo") {
    return "solicitado agora mesmo";
  }
  
  return `solicitado ${timeAgo}`;
}
